module.exports = __webpack_public_path__ + "images/category_lp/hobby/bg-star-sp_12ab97dedf5f5c2ce7ef6acb19eafe75.png";